'use client';
import { useState, useEffect } from 'react';

const DEFAULT_SIZES = {
    mobile: { height: 667, width: 375 },
    tablet: { height: 1024, width: 768 },
    desktop: { height: 900, width: 1440 }
};
const useWindowSize = (defaultSize, handleWindowResize) => {
    const [windowSize, setWindowSize] = useState(typeof window === "undefined" ? DEFAULT_SIZES[defaultSize || 'desktop'] : {
        height: window.innerHeight,
        width: window.innerWidth || 0
    });
    useEffect(() => {
        setWindowSize({ height: typeof window === "undefined" ? 0 : window.innerHeight, width: typeof window === "undefined" ? 0 : window.innerWidth || 0 });
    }, []);
    useEffect(() => {
        function handleResize() {
            if (!window)
                return;
            const size = { height: window.innerHeight, width: window.innerWidth };
            setWindowSize(size);
            handleWindowResize === null || handleWindowResize === void 0 ? void 0 : handleWindowResize(size);
        }
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    const isMobile = windowSize.width <= 768;
    return { windowSize, setWindowSize, isLoading: typeof window === "undefined", isMobile };
};

export { useWindowSize };
